import http from '@/plugins/axios/axios';

export default class GerenciamentoRelogiosTarefasService {   

    listarTarefas(cnpjId) {
        return http.get('/api/adm/relogio-tarefa/listar-tarefas/'+cnpjId);
    }

    excluirTarefa(id) {
        return http.delete('/api/adm/relogio-tarefa/deletar-tarefa/'+id);
    }

    limparTarefas(cnpjId) {
        return http.delete('/api/adm/relogio-tarefa/limpar-tarefas/'+cnpjId);
    }
}